import React, { useEffect } from "react";
import { useMediaQuery } from "react-responsive";

import {
  convertToIST12HourFormat,
  NoItemsLeftInTable,
  roundToThreeDecimal,
} from "../../../../../helpers/helpers";

function BidingHistory({ bidderDetails, isMobileView = false }) {
  const isTablet = useMediaQuery({ query: "(max-width: 990px)" });
  const [allBidderHistory, setAllBidderHistory] = React.useState([]);

  useEffect(() => {
    if (Array.isArray(bidderDetails?.[0]?.bidHistory)) {
      setAllBidderHistory(bidderDetails?.[0]?.bidHistory);
    }
  }, [bidderDetails]);

  return (
    <div className={`${!isTablet && "table-container-style"}`}>
      <table
        className={`responsive-table centered ${isTablet
            ? "auction_table table-style"
            : "custom-table-style liveAuction-table"
          } ${isMobileView ? "liveTableInMobile" : ""}`}
      >
        <thead>
          <tr>
            <th >H Bidder</th>
            <th >Highest Bid</th>
            <th >Bidding Type</th>
            <th >Bid time</th>
          </tr>
        </thead>
        <tbody>
          {allBidderHistory?.slice(0, 10).map((item, index) => (
            <tr
              key={index}
              style={{
                backgroundColor:
                  item?.isItMyBid === bidderDetails[0]?.myBidColor && "#FBF1FF",
              }}
            >
              <td>H {index + 1}</td>
              <td>{roundToThreeDecimal(item?.bidAmount)}</td>
              <td>{item?.bidType || "Manual"}</td>
              <td>{convertToIST12HourFormat(item?.createdAt)}</td>
            </tr>
          ))}
        </tbody>
      </table>
      {allBidderHistory?.length === 0 && <NoItemsLeftInTable />}
    </div>
  );
}

export default BidingHistory;
